import type { GarminSleepRaw } from '@/api/types/garmin'

/** /garmin/sleep の応答から、その日に起きた睡眠すべて（昼寝を含む）を古い順に取り出す */
export const listSleepEpisodes = (sleep: GarminSleepRaw | null | undefined): GarminSleepRaw[] => {
  if (!sleep) return []
  if (sleep.episodes && sleep.episodes.length > 0) return sleep.episodes
  return sleep.dailySleepDTO ? [sleep] : []
}
